import * as moment from "moment";

const Time = (function () {
    var FormatSeconds = function (seconds: number) {
        if (!seconds || isNaN(seconds)) throw new Error("Missing input value");

        var timeMinutes = Math.floor(seconds / 60);
        var timeSeconds = seconds % 60;
        var result = "";
        if (timeMinutes > 0) result += timeMinutes + "m ";
        if (timeSeconds > 0) result += timeSeconds + "s";
        result = result.trim();
        return result;
    };

    const GetDatesBetween = function (startDate: string, stopDate: string) {
        let dateArray = [];
        let currentDate = moment(startDate);
        const lastDate = moment(stopDate);
        while (currentDate <= lastDate) {
            dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
            currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
    };

    return {
        GetDatesBetween,
        FormatSeconds,
    };
})();

export default Time;

export function IsToday(dateTime: string) {
    const input = moment(dateTime).local();
    const now = moment().local();
    const isToday = input.isSame(now, "day");
    return isToday;
}
